// import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Estado } from "../../actions/Estado";
import { useProducto } from "../../actions/Producto.jsx";
import style from "../../styles/form.module.css";
import { Sparkle } from "lucide-react";

function ABMProductos() {
   // const token = localStorage.getItem("token");
   // const url = process.env.REACT_APP_URL_DIR + "product";
   const estados = Estado();
   // const queryClient = useQueryClient();
   const { crearProducto } = useProducto();
   // var urlProd = url;
   // var metodo = "POST";

   const location = useLocation();
   const { state } = location;

   const navigate = useNavigate();
   const [input, setInput] = useState({
      id_primary: state ? state.id_primary : 0,
      id: state ? state.id : 0,
      companyId: state ? state.companyId : 0,
      descripcion: state ? state.descripcion : "",
      cod_proveedor:  "",
      dolar: state ? state.dolar : 0,
      stock: state ? state.stock : 0,
      size:  0,
      gauge: 0,
      esteril: 0,
      tipoprod: 3,
      cod_status: state ? state.cod_status : "1",
   });
   
   var btnGrabar = true;
   
   console.log('input: ', input);
   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }

   const handleSubmit = async (e) => {
      e.preventDefault();
      console.log("handleSubmit: ", input);
      await crearProducto.mutateAsync(input);
      navigate("/Productotattoo");
   };

   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <div style={{ display: "flex", gap: "10px" }}>
                  <Sparkle style={{ color: "white" }} />
                  <h2 className="justify-self-center">Datos del Producto</h2>
                  </div>
                  <br />
                  <div>
                     {input.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Producto id : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : null}
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Descripción:{" "}
                     </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Descripcion Producto"
                        name="descripcion"
                        value={input.descripcion}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  {/* <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Cod.Interno Proveedor:{" "}
                     </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Codigo Interno del Proveedor"
                        name="cod_proveedor"
                        value={input.cod_proveedor}
                        onChange={handleChange}
                        required
                     />
                  </div> */}

                  <div className="d-flex p-1">
                     <div className={style.input_group}>
                        <span className={style.input_group_text}>Precio:</span>
                        <label htmlFor="dolar"></label>
                        <input
                           type="number"
                           id="dolar"
                           name="dolar"
                           value={input.dolar}
                           onChange={handleChange}
                           className={style.input_field_number}
                        />{" "}
                        <span className={style.input_group_text}>$</span>
                     </div>
                     <div className={style.ciaContainer}>
                        <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              Stock:
                           </span>
                           <input
                              type="number"
                              id="stock"
                              name="stock"
                              value={input.stock}
                              onChange={handleChange}
                              className={style.input_field_number}
                           />
                        </div>

                     </div>
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="cod_status"
                        id="cod_status"
                        onChange={(e) => handleChange(e)}
                        value={input.cod_status}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((dat) => {
                              return (
                                 <option
                                    selected
                                    value={dat.id}
                                    key={dat.id}
                                 >{`${dat.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           {state ? "GRABAR" : "AGREGAR"}
                        </button>
                     ) : null}
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <button
                        className={style.inputBtnNew}
                        onClick={() => {
                           navigate("/Productotattoo");
                        }}
                     >
                        VOLVER
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
}

export default ABMProductos;
